import { createStructureForKennziffern, prepareStructureForKennziffern } from './functions/createStructureForKennziffern';
import { DataService } from '../../services/data_service';
import { delDataKennziffern, saveDataKennziffern, transformWerteKennziffern } from './functions/dataHandlingForKennziffern';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { StructureTool } from '../../core/forms/helpers/structure_tool';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

/*
TODO:
- Plausi auf doppelte Jahr
- Minimum-Jahr anhand Konfiguration
- Jahr vorbelegen mit Max-Jahr + 1
*/

interface DateneingabeEnergiedatenKennziffernProps extends React.ClassAttributes<any> {
    data: any;
    reloadData?: () => void;
    routing?: any;
    standortSelected: any;
}

export class DateneingabeEnergiedatenKennziffern extends React.Component<DateneingabeEnergiedatenKennziffernProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    prepare(): void {
        // Kennziffern-Definition holen und nach den Gewerken des Unternehmens filtern
        // Dazu die dynamischen Kennziffern (nur für dieses Unternehmen) holen
        const {kenn_dyn, kenn_def} = prepareStructureForKennziffern(this.props.data);
        // Wir erzeugen eine Struktur analog der statischen strukturen
        const struct = createStructureForKennziffern(kenn_def, kenn_dyn, IDs.ENT_KENNZIFFERN_GENERATED);
        // Die Struktur wird nun mit einem dynamischen Schlüssel ins Strucute-Tool gegeben
        const struct_tool = new StructureTool(IDs.MOD_ETOOL);

       // console.log('Struct', struct);
        struct_tool.addStructure(IDs.MOD_ETOOL, IDs.ENT_KENNZIFFERN_GENERATED, struct);
    }

    render(): JSX.Element {
        const werte = this.props.data[IDs.ENT_KENNZAHLEN_WERTE];
        // const data_real = transformWerteKennziffern(werte);
        // console.log('DS', this.strucutre_dynamic, data_real);
        // const data: Array<any> = []; // this.transformWerte(werte);
        const data: Array<any> = transformWerteKennziffern(werte);
        this.prepare();
        const bundle = {standort_tid: this.props.data[IDs.ENT_STANDORT]};
        return (
            <div>
                <WFormsTableWrapper
                    isManual={true}
                    entity={IDs.ENT_KENNZIFFERN_GENERATED}
                    data={data}
                    bundle={bundle}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    addLabel={'Kennzahl erfassen'}
                    // onFormChange={this.onFormChange}
                    onSaveDone={(entityName: string, values) =>  {
                       // this.saveData(values);
                       saveDataKennziffern(values, this.props.data, this.dataService, this.triggerService);
                    }}
                    onDelDone = {(entityName: string, row) => {
                        delDataKennziffern(row, this.props.data, this.dataService, this.triggerService);
                    }}
                />
            </div>
        );
    }
}
